import React from 'react'
import { ProductPackageWithMinAndMaxQuantity } from 'resources/catalog/packages/eventPackage/package/common'
import { intersect } from 'resources/operations/events/utils'
import { ProductPackage } from 'services/api/entities/catalog/packages/common'
import { LinkedCustomerUser } from 'services/api/entities/catalog/types'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { getById } from 'services/utils'
import TailoredFields from 'ui-shared/WrappedInputs/TailoredFields'

type Props<T> = {
  arrayFieldSource: T[]
}

const CustomerEmailChip = <
  T extends ProductPackageWithMinAndMaxQuantity & {
    customersFull: LinkedCustomerUser[]
  }
>({
  arrayFieldSource,
}: Props<T>) => {
  const record = useKRecordContext<ProductPackage>()
  if (!record) return null

  const productFull = record.products.map((product) =>
    getById(arrayFieldSource, product.id)
  )
  const onlyWithPrivateCustomers = productFull.filter(
    (product) => !!product && !!product.customers && !!product.customers.length
  )
  const customersFull = intersect(
    onlyWithPrivateCustomers.map((product) => product?.customersFull!)
  )
  const newRecord = {
    ...record,
    customers: customersFull.map((c) => c.id),
    customersFull,
    organizations: [],
    organizationsFull: [],
  }
  return (
    <TailoredFields
      record={newRecord}
      arrayFieldSource={'customersList'}
      chipFieldSource={'email'}
      tailoredListField={'customersFull'}
      label={'form.fields.customers'}
    />
  )
}

export default CustomerEmailChip
